import { useMemo } from 'react';

export function useAzureAsset(url?: string | null): string {
  return useMemo(() => {
    if (!url || url === 'null') {
      return '/your-default-avatar.png'; // ✅ Always return a fallback string
    }

    if (/^((http|https):\/\/)/.test(url)) {
      return url;
    }

    return `${process.env['REACT_APP_HIPAA_VIDEO_URI']}${url}`;
  }, [url]);
}
